import "./PresetBadge.scss";
import {Popover} from "antd";
import {ADD_ONS, levelLabel} from "./permissionModel";
import {PresetBadgeInfo} from "./userAccess";

const HOVER_DELAY_SECONDS = 0.3;

function PresetPopoverContent({badge}: {badge: PresetBadgeInfo}) {
  const addOnLabels = ADD_ONS.filter((a) => badge.addOns.includes(a.key)).map((a) => a.label);

  return (
    <div className={"preset-popover"}>
      <div className={`preset-popover-title level-${badge.level ?? "none"}`}>
        <span className={"dot"}/>
        {badge.label}
      </div>
      {badge.description && <p>{badge.description}</p>}
      <div className={"preset-popover-chips"}>
        {badge.level && <span className={"chip base"}>{levelLabel(badge.level)}</span>}
        {addOnLabels.map((label) => <span className={"chip addon"} key={label}>{label}</span>)}
      </div>
    </div>
  );
}

export function PresetBadge({badge}: {badge: PresetBadgeInfo}) {
  return (
    <Popover
      trigger={["hover", "click"]}
      mouseEnterDelay={HOVER_DELAY_SECONDS}
      placement={"bottomRight"}
      content={<PresetPopoverContent badge={badge}/>}
      overlayClassName={"preset-popover-overlay"}
    >
      <button type={"button"} className={`preset-badge level-${badge.level ?? "none"}`}>{badge.label}</button>
    </Popover>
  );
}
